var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPixIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "48px",
    height: "48px",
    fillRule: "nonzero",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#baa78e",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(5.33333,5.33333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9,12h-0.68l8.04,-8.04c2.62,-2.61 6.86,-2.61 9.48,0l8.04,8.04h-0.68c-1.6,0 -3.11,0.62 -4.24,1.76l-6.8,6.77c-0.59,0.59 -1.53,0.59 -2.12,0l-6.8,-6.77c-1.13,-1.14 -2.64,-1.76 -4.24,-1.76z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1,36h0.68l-8.04,8.04c-2.62,2.61 -6.86,2.61 -9.48,0l-8.04,-8.04h0.68c1.6,0 3.11,-0.62 4.24,-1.76l6.8,-6.77c0.59,-0.59 1.53,-0.59 2.12,0l6.8,6.77c1.13,1.14 2.64,1.76 4.24,1.76z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.04,28.74l-5.26,5.26h-2.68c-1.07,0 -2.07,-0.42 -2.83,-1.17l-6.8,-6.78c-1.36,-1.36 -3.58,-1.36 -4.94,0l-6.8,6.78c-0.76,0.75 -1.76,1.17 -2.83,1.17h-2.68l-5.26,-5.26c-2.61,-2.62 -2.61,-6.86 0,-9.48l5.26,-5.26h2.68c1.07,0 2.07,0.42 2.83,1.17l6.8,6.78c0.68,0.68 1.58,1.02 2.47,1.02c0.89,0 1.79,-0.34 2.47,-1.02l6.8,-6.78c0.76,-0.75 1.76,-1.17 2.83,-1.17h2.68l5.26,5.26c2.61,2.62 2.61,6.86 0,9.48z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPixIcon);
export default __webpack_public_path__ + "static/media/pix-icon.e0a2cc4be5e2c137777be5fe48bba1eb.svg";
export { ForwardRef as ReactComponent };